import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">TE</span>
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold text-gray-900">TimeshareExit.Expert</h1>
                <p className="text-xs text-gray-500">Scam-Free • DIY • Guaranteed</p>
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Home
            </Link>
            <Link to="/calculator" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Savings Calculator
            </Link>
            <a href="#scam-exposed" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Scam Exposed
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
              Success Stories
            </a>
            
            {/* Call-to-action button */}
            <Link to="/register" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium">
              Get Professional Guide
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 border-t border-gray-200">
            <div className="pt-4 space-y-2">
              <Link 
                to="/" 
                className="block text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/calculator" 
                className="block text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Savings Calculator
              </Link>
              <a 
                href="#scam-exposed" 
                className="block text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Scam Exposed
              </a>
              <a 
                href="#testimonials" 
                className="block text-gray-700 hover:text-blue-600 font-medium py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Success Stories
              </a>
              
              {/* Mobile CTA */}
              <Link 
                to="/register" 
                className="block bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-colors mt-4 text-center font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Get Professional Guide
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}
